class ProductStitcher extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            productInfo: "[js-hb-main-product]",
            productReviews: "[js-product-review]",
            objectImageWithText: "[js-object-image-with-text]",
            objectTableColumn: "[js-object-table-column]",
            objectOverlayItem: "[js-object-overlay-item]",
            sizeGuide: "[js-size-guide]",
            stitcherItem: "[js-stitcher-item]"
        };
      
        this.sections = {
        
            mainProduct: { 
                element: document.querySelector(this.selectors.productInfo), 
                selector: this.selectors.productInfo, 
                initEvents: ["size-guide:init", "mainProductSectionMarquee:init"] 
            },
             productReviews: { 
                 element: document.querySelector(this.selectors.productReviews), 
                 selector: this.selectors.productReviews 
             },
             objectImageWithText: { 
                 element: document.querySelector(this.selectors.objectImageWithText), 
                 selector: this.selectors.objectImageWithText
             },
             objectTableColumn: { 
                 element: document.querySelector(this.selectors.objectTableColumn), 
                 selector: this.selectors.objectTableColumn
             },
             objectOverlayItem: { 
                 element: document.querySelector(this.selectors.objectOverlayItem), 
                 selector: this.selectors.objectOverlayItem
             },
             sizeGuide: { 
                 element: document.querySelector(this.selectors.sizeGuide), 
                 selector: this.selectors.sizeGuide,
                 initEvents: ["size-guide:init", "optiscroll:init"] 
             }
        };

        this.stitcherItems = this.querySelectorAll(this.selectors.stitcherItem);

        this.init();
    }

    init() {
        // this.stitcherItems.forEach(stitcherItem =>
        //     stitcherItem.addEventListener("click", this.renderSectionFromFetch.bind(this))
        // );
    }

    renderSectionFromFetch(evt) {
        evt.preventDefault();
        const { currentTarget } = evt;
        const handle = currentTarget.getAttribute("data-product-handle");
        const variantsJson = JSON.parse(currentTarget.querySelector("[js-variants-json]").textContent);
        const current_variant = variantsJson.find( variant => variant.option1 === localStorage.getItem("selected-option"));

        this.updateLoading();
        Object.values(this.sections).forEach(({ element, selector, initEvents = [] }) => {
          
            element && this.renderSection(handle, element, selector, current_variant, ...initEvents);
        });
    }

    updateURLHash(handle) {
        const url = `/products/${handle}`;
        window.history.replaceState({}, '', url);
    }

    updateLoading() {
        this.sections.mainProduct.element.classList.add("section--loading");
    }

    renderSection(handle, container, selector, current_variant, ...initEvents) {
        // const url = current_variant ? `/products/${handle}?variant=${current_variant.id}&section_id=${container.getAttribute("data-section")}` :  `/products/${handle}?section_id=${container.getAttribute("data-section")}`;
        // this.ajaxSection(url, container, selector, handle, initEvents);
        let url = current_variant ? `/products/${handle}?variant=${current_variant.id}&section_id=${container.getAttribute("data-section")}` :  `/products/${handle}?section_id=${container.getAttribute("data-section")}`;

        const customTemplate = document.body.classList[0]?.split('template-')?.pop();

        if (customTemplate) {

            url = `${url}&view=${customTemplate}`;

        }
    }

    ajaxSection(url, container, selector, handle, initEvents = []) {
        fetch(url)
            .then(response => response.text())
            
            .then(html => {
                const ajaxContainer = new DOMParser()
                    .parseFromString(html, 'text/html')
                    .querySelector(selector);
                
                if (ajaxContainer) {
                    selector === this.selectors.productInfo 
                    ? container.outerHTML = ajaxContainer.outerHTML
                    : container.innerHTML = ajaxContainer.innerHTML
                }

                if(selector === this.selectors.productInfo) { 
                    window.Shopify.theme.sections.registered.product(document.querySelector('[data-section-type="product"]'));
                    document.querySelector("title").textContent = document.querySelector("[js-page-title]")?.getAttribute("data-page-title");
                    document.querySelector("meta[name='description']").content = document.querySelector("[js-page-title]")?.getAttribute("data-page-description");
                    timesactScriptNew(jQuery191)
                }

                initEvents.forEach(eventName => document.dispatchEvent(new CustomEvent(eventName)));
                selector === this.selectors.objectTableColumn || selector === this.selectors.sizeGuide ||  selector === this.selectors.objectImageWithText || selector === this.selectors.objectOverlayItem ;
                selector === this.selectors.productReviews ? yotpo.initWidgets() : null;
                selector === this.selectors.productInfo ? yotpo.initWidgets() : null;
                this.updateURLHash(handle);
            })
            .catch(err => {
                console.log(err)
            })
    }
}

customElements.define('product-stitcher', ProductStitcher);